module.exports = __webpack_public_path__ + "img/billete.6ee02bc3.svg";